import { TFunction } from "i18next";
import * as Yup from "yup";

export const phoneNumberValidator = (t: TFunction) =>
  Yup.string().test("phoneNumberValidator", t("validation.invalidPhoneNumber"), value =>
    /^[\d]{1}[-\d]{7,16}$|[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3,4}[-\s.]?[0-9]{4,6}$/im.test(value)
  );
